export default {
  products: 'Products',
  resources: 'Resources',
  support: 'Support',
  downloadApp: 'Download App',
  followUs: 'Follow Tameeni',
  languageToggle: 'العربية',
  login: 'Log in',
  logout: 'Logout',
  myAccount: 'My Account',
  accountSettings: 'Account Settings',
  myDashboard: 'My Dashboard',
} as const
